import {Button as BaseButton} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'

import {theme} from '../theme'

const styles = {
  root: {
    color: '#8F8C89',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'unset',
      color: theme.palette.common.black,
    },
  },
  contained: {
    border: `${theme.spacing(0.2)}px solid ${theme.palette.grey[200]}`,
    padding: theme.spacing(1.8),
    backgroundColor: 'transparent',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: theme.palette.common.black,
    },
  },
  containedPrimary: {
    color: theme.palette.common.black,
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: '#F7CD46',
      borderColor: '#F7CD46',
    },
    '&$disabled': {
      opacity: 0.5,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.black,
    },
  },
  containedSecondary: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
  },
  containedSizeSmall: {
    fontSize: 14,
    padding: theme.spacing(0.8, 1.8),
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(1.3),
      paddingLeft: theme.spacing(1.3),
    },
  },
  textSizeSmall: {
    fontSize: 14,
    padding: '6px 18px',
    borderRadius: 10,
    fontWeight: theme.typography.fontWeightRegular as any,
  },
  endIcon: {},
  disabled: {},
  label: {},
}

export default withStyles(styles, {name: 'LPCButton'})(BaseButton)
